// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fn-chart-trend[data-v-204e93e6]{width:74.125rem;height:24.125rem}.fn-position-relative[data-v-204e93e6]{position:relative}.c8-explanation[data-v-204e93e6]:hover{height:auto}table[data-v-204e93e6]{table-layout:fixed}.scrollBottom[data-v-204e93e6]{height:1.20773rem;opacity:0}", ""]);
// Exports
module.exports = exports;
